module.exports = __webpack_public_path__ + "img/pro2.570f3d2e.png";